export function resolveApiAssetUrl(path: string | null | undefined): string {
  if (!path) return ''

  const trimmed = path.trim()
  if (!trimmed) return ''

  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith('data:') || trimmed.startsWith('blob:')) {
    return trimmed
  }

  const apiBase = String(import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '')
  const normalizedPath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`

  return apiBase ? `${apiBase}${normalizedPath}` : normalizedPath
}
